import { request } from "./http";

export interface Complaint {
  id: string;
  classification: string;
  subject: string;
  body: string;
  status: "open" | "under_review" | "resolved" | "rejected";
  opened_at: string;
  sla_due_at: string;
  resolved_at: string | null;
  resolution_note: string | null;
  assigned_to: string | null;
}

export interface AdminComplaint extends Complaint {
  user_id: string;
  user_email: string | null;
  user_name: string | null;
}

export interface ComplaintCreate {
  classification: string;
  subject: string;
  body: string;
}

export const complaints = {
  open: (body: ComplaintCreate) =>
    request<Complaint>("/api/v1/complaints", { body }),
  list: () => request<Complaint[]>("/api/v1/complaints"),

  admin: {
    list: (params: { status?: Complaint["status"]; overdue_only?: boolean; limit?: number } = {}) => {
      const qs = new URLSearchParams();
      if (params.status) qs.set("status", params.status);
      if (params.overdue_only) qs.set("overdue_only", "true");
      if (params.limit) qs.set("limit", String(params.limit));
      return request<AdminComplaint[]>(
        `/api/v1/admin/complaints${qs.toString() ? "?" + qs : ""}`,
      );
    },
    patch: (
      id: string,
      body: { status?: Complaint["status"]; assigned_to?: string; resolution_note?: string },
    ) =>
      request<AdminComplaint>(`/api/v1/admin/complaints/${id}`, {
        method: "PATCH",
        body,
      }),
  },
};
